import { FC } from 'react';
import { Grid, Alert } from '@mui/material';
import { useGuardianState } from '../../../../contexts/guardian.context';
import { useTranslation } from 'src/hooks/useTranslationHook';
import { GuardianMessagingProvider } from '../../../../contexts/guardianMessaging.context';
import GuardianMessagingView from './guardianMessaging.view';

const GuardianCommunicationsView: FC = () => {
  const { translateText } = useTranslation();
  const { selectedChildId } = useGuardianState();

  if (!selectedChildId) {
    return (
      <Grid container spacing={3} sx={{ p: 3 }} data-testid="guardian-communications-container">
        <Grid item xs={12}>
          <Alert severity="info">{translateText('guardian.selectChild')}</Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <GuardianMessagingProvider studentId={selectedChildId}>
      <Grid container spacing={3} sx={{ p: 3, height: '100%' }} data-testid="guardian-communications-container">
        <Grid item xs={12} sx={{ height: 'calc(100% - 24px)' }}>
          <GuardianMessagingView />
        </Grid>
      </Grid>
    </GuardianMessagingProvider>
  );
};

export default GuardianCommunicationsView;
